import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/driver/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/driver/detail', Object.assign({}, options, { params }));

export const beforeDelete = (params, options) =>
  request.post('/api/park/region/beforeDelete', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/park/driver/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/driver/save', params, options);

export const update = (params, options) => request.post('/api/park/driver/update', params, options);

export const driverSelections = (params, options) =>
  request.post('/api/park/driver/selections', qs.stringify(params), options);

export const syncDrivers = (params, options) =>
  request.post('/api/park/driver/sync', qs.stringify(params), options);

export const getSpaceList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/parkSpaceList', Object.assign({}, options, { params }));

export const removeCar = (params, options) =>
  request.post('/api/park/vehicle/car/remove', params, options);
